function isDateEmpty(date) {
    return (
        (typeof date === 'undefined') ||
        (date === null) ||
        (date === '') ||
        (date === '0000-00-00') ||
        (date === '0000-00-00 00:00:00')
        // !moment(date).isValid() // долго
    );
}

export const formatDate = function (date) {
    if (isDateEmpty(date)) return '';
    var y = date.substr(0, 4);
    var m = date.substr(5, 2);
    var d = date.substr(8, 2);

    var months = {
        '01': 'янв',
        '02': 'фев',
        '03': 'мар',
        '04': 'апр',
        '05': 'мая',
        '06': 'июн',
        '07': 'июл',
        '08': 'авг',
        '09': 'сен',
        '10': 'окт',
        '11': 'ноя',
        '12': 'дек',
    };
    return '' + d + ' ' + months[m] + ' ' + y;
}
